<template>
    <div id="status-signalr" v-if="msg">
        <div id="fundo" class="dx-theme-background-color"></div>
        <div>{{msg}}</div>        
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    data() {
        return {
            msg: ''
        }
    },
    computed: {
        ...mapGetters(['signalRStatus'])
    },
    watch: {
        signalRStatus(newVal) {
            this.updateMessage()
        }
    },
    created() {
        this.updateMessage()
    },
    methods: {
        updateMessage() {
            this.msg = ''
            switch (this.signalRStatus) {
                case 'reconectando':
                    this.msg = this.$vistra.globalize('reconectando')
                    break;
                case 'desconectado':
                    //this.msg = 'Desconectado'
                    break;
            }
        }
    }
}
</script>

<style lang="sass" scoped>
    #status-signalr
        width: 100%
        height: 100%
        position: absolute
        display: flex
        justify-content: center
        align-items: center
        font-size: 20px
        z-index: 1000

        #fundo
            width: 100%
            height: 100%
            position: absolute
            opacity: 0.8
</style>